import React, { useState } from 'react';
import ScrollingBanner from './ScrollingBanner';
import { 
  Grid, 
  Container, 
  Box, 
  Typography,
} from '@mui/material';
import ProductCard from './ProductCard';
import { products } from '../data/products';
import Navbar from './layout/Navbar';
import messageImage from '../data/message1.png'; // Import the image


const bestSellers = products.slice(0, 3);

const Home = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const categories = ['All', 'Floral', 'Fresh', 'Oriental', 'Woody', 'Citrus'];

  return (
    <>
      <ScrollingBanner />
      <Navbar 
        categories={categories}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
      />
      <Container maxWidth="lg" sx={{ mt: 4 }}>
        {/* Best Sellers Section */}
        <Box sx={{ mb: 6 }}>
          <Typography 
            variant="h4" 
            sx={{ 
              mb: 3, 
              color: '#2C3E50',
              fontFamily: 'serif',
              textAlign: 'center',
              fontWeight: 'bold',
              textShadow: '2px 2px 4px rgba(0,0,0,0.1)'
            }}
          >
            Best Sellers
          </Typography>
          <Grid container spacing={4}>
            {bestSellers.map(product => (
              <Grid item xs={12} sm={6} md={4} key={product.id}>
                <ProductCard product={product} isBestSeller={true} />
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Dynamic Category Title */}
        <Typography 
          variant="h4" 
          sx={{ 
            mb: 3, 
            color: '#2C3E50',
            fontFamily: 'serif',
            textAlign: 'center',
            fontWeight: 'bold'
          }}
        >
          {selectedCategory === 'All' ? 'All Perfumes' : selectedCategory}
        </Typography>

        {/* All Products Section */}
        <Grid container spacing={4}>
          {products
            .filter(product => selectedCategory === 'All' || product.category === selectedCategory)
            .map(product => (
              <Grid item xs={12} sm={6} md={4} key={product.id}>
                <ProductCard product={product} />
              </Grid>
            ))}
        </Grid>
      </Container>
    </>
  );
};

export default Home;
